<template>
    <div>
        <h1 class="mb-5">{{ $l10n.__('Documents en attente de vérification') }}</h1>
        <upload-form :linkedtype="linkedtype" :hash="hash" />
        <div class="fs-3 wp-4 mx-auto acenter">
            <p class="black m-0 mb-2">{{ $l10n.__('Envoyer des documents par email') }}</p>
            <p class="grey m-0 mb-2">
                {{
                    $l10n.__(
                        'ocr.%s@sellsy.net depuis l’adresse d’un collaborateur du compte.',
                        corpId,
                    )
                }}
            </p>
            <p class="grey m-0 mb-2">
                {{ $l10n.__('PDF de maximum 5 pages et inférieur à 5MB.') }}
            </p>
            <p class="grey m-0">{{ $l10n.__('(Envoi limité à 50 fichiers à la fois)') }}</p>
        </div>
        <div v-if="canValidatePurInvoice" class="flex-row flex-right">
            <CompassButton
                :label="$t.__('ocr.OcrList.check_all_documents')"
                :type="CompassEnums.ButtonType.PRIMARY"
                :disabled="!rows.length"
                @click="verifyAll"
            />
        </div>
        <Listing
            v-if="listingData"
            v-bind="listingData"
            :storeModule="storeModule"
            @listinghash="storeRows"
        />
    </div>
</template>
<script>
import UploadForm from 'vcomponents/ocr/UploadForm.vue';
import Listing from 'vcomponents/listing/ListingSwitch.vue';
import LocalStorage from 'Core/commons/LocalStorage';
import { goToUrl } from 'js/vue/helpers';
import OcrListing from 'stores/ocrListing';
import OcrListingLegacyResolver from 'api/routing/listings/OcrListingLegacyResolver';

export default {
    components: {
        'upload-form': UploadForm,
        Listing,
    },
    props: {
        linkedtype: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            hash: null,
            listingData: null,
            ocrLocalStorage: new LocalStorage('ocr', 'form.verification'),
        };
    },
    computed: {
        rows() {
            return this.hash ? this.$store.state[this.hash].rows : [];
        },
        storeModule() {
            return OcrListing;
        },
        canValidatePurInvoice() {
            return this.hash
                ? this.$store.state[this.hash].metadatas.user_can_validate_pur_invoice
                : false;
        },
        corpId() {
            return this.$store.state.corp.id;
        },
    },
    created() {
        const listingResolver = new OcrListingLegacyResolver();
        listingResolver.feed(this.$route);
        this.listingData = this.$route.params;

        if (!!this.ocrLocalStorage.get()) {
            this.ocrLocalStorage.delete();
        }
        EventBus.on(
            'ocr:completed',
            _.debounce(() => {
                EventBus.emit('listing:refresh');
            }, 1000),
        );
        EventBus.on(
            'ocr:failed',
            _.debounce(() => {
                EventBus.emit('listing:refresh');
            }, 1000),
        );
    },
    unmounted() {
        EventBus.off('ocr:failed');
        EventBus.off('ocr:completed');
    },
    methods: {
        storeRows(hash) {
            this.hash = hash;
        },
        verifyAll() {
            this.ocrLocalStorage.set({
                rows: this.$store.state[this.hash].rows,
                multipleVerify: true,
            });
            goToUrl(`/purchase/incoming/verification/${this.ocrLocalStorage.get().rows[0].id}`);
        },
    },
};
</script>
